<template>
  <div class="data-list">
    <div ref="body" class="datatable-wrapper">
      <table class="datatable">
        <thead ref="thead" class="datatable-head">
          <tr class="row-header">
            <th class="department" ref="th-department">
              {{ $t('task_types.fields.department') }}
            </th>
            <th class="task-type" ref="th-type">
              {{ $t('tasks.fields.task_type') }}
            </th>
            <th class="status" ref="th-status">
              {{ $t('tasks.fields.task_status') }}
            </th>
            <th class="assignees" ref="th-assignees">
              {{ $t('tasks.fields.assignees') }}
            </th>
            <th class="start-date" ref="th-estimation">
              {{ $t('tasks.fields.start_date') }}
            </th>
            <th class="due-date" ref="th-estimation">
              {{ $t('tasks.fields.due_date') }}
            </th>
            <th class="empty" ref="">
              &nbsp;
            </th>
            <th class="delete-button">
              &nbsp;
            </th>
          </tr>
        </thead>

        <tbody
          v-if="!isLoading"
          class="datatable-body"
        >
          <tr
            :ref="'task-' + task.id"
            :key="task.id"
            :class="{
              'task-line': true,
              'datatable-row': true,
              // selected: selectionGrid[task.id]
            }"
            :style="getRowStyle(task)"
            @click="selectTask($event, task)"
            v-for="(task, index) in sortedTaskList"
          >
            <td
              class="department"
              :style="getDepartmentStyle(task)"
              :rowspan="getDepartmentRowspan(index)"
              v-if="getDepartmentRowspan(index)"
            >
              {{ getDepartmentName(task) }}
            </td>
            <td
              class="task-type"
              :style="getTypeStyle(task)"
            >
              {{ task.task_type.name }}
            </td>
            <validation-cell
              class="status unselectable"
              :task-test="task"
              :is-border="false"
              :is-assignees="false"
              :is-due-dates="false"
              :selectable="false"
              :is-static="true"
            />
            <multi-people-name-cell
              class="assignees"
              :peopleIds="task.assignees"
            />
            <!-- <td class="assignees">
              <div class="flexrow">
                <people-avatar-with-menu
                  class="flexrow-item"
                  :key="task.id + '-' + personId"
                  :person="personMap.get(personId)"
                  :size="30"
                  :font-size="17"
                  v-for="personId in task.assignees"
                />
              </div>
            </td> -->
            <td class="start-date">
              <date-field
                class="flexrow-item"
                :with-margin="false"
                :value="getDate(task.start_date)"
                @input="updateStartDate"
              />
              <!-- <span v-else>
                {{ formatDate(task.start_date) }}
              </span> -->
            </td>
            <td class="due-date">
              <date-field
                class="flexrow-item"
                :with-margin="false"
                :value="getDate(task.due_date)"
                @input="updateDueDate"
              />
              <!-- <span v-else>
                {{ formatDate(task.due_date) }}
              </span> -->
            </td>
            <td class="empty">
            </td>
            <td>
              <!-- <button-simple
                class="delete-button"
                icon="delete"
                @click="onDeleteClick(task)"
              /> -->
            </td>
            <!-- <th class="empty">
            </th> -->
          </tr>
        </tbody>
      </table>
      <table-info
        :is-loading="isLoading"
        :is-error="isError"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone'
import { formatListMixin } from '@/components/mixins/format'
import { entityListMixin } from '@/components/mixins/entity_list'
import { domMixin } from '@/components/mixins/dom'
import { getTaskTypePriorityOfProd } from '@/lib/productions'
import {
  formatSimpleDate,
  getDatesFromStartDate,
  getDatesFromEndDate,
  parseSimpleDate,
  minutesToDays
} from '@/lib/time'

import DateField from '@/components/widgets/DateField'
// import PeopleAvatarWithMenu from '@/components/widgets/PeopleAvatarWithMenu'
import TableInfo from '@/components/widgets/TableInfo'
import ValidationCell from '@/components/cells/ValidationCell'
import MultiPeopleNameCell from '@/components/cells/MultiPeopleNameCell'
// import ButtonSimple from '@/components/widgets/ButtonSimple'

export default {
  name: 'management-task-list',
  mixins: [domMixin, formatListMixin, entityListMixin],

  components: {
    DateField,
    // PeopleAvatarWithMenu,
    TableInfo,
    // ButtonSimple,
    ValidationCell,
    MultiPeopleNameCell
  },

  data () {
    return {
      selectionGrid: {},
      sortedTaskList: [],
    }
  },

  props: {
    isError: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    departmentFilter: {
      type: Array,
      default: () => []
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters([
      'productionManagementTaskTypes',
      'assetMap',
      'editMap',
      'departmentMap',
      'nbSelectedTasks',
      'personMap',
      'user',
      'selectedTasks',
      'shotMap',
      'isCurrentUserManager',
      'isCurrentUserSupervisor',
      'taskTypeMap',
      'taskMap',
      'taskStatusMap',
      'isDarkTheme',
      'currentProduction',
      'organisation'
    ]),
  },

  methods: {
    ...mapActions([
      'addSelectedTask',
      'addSelectedTasks',
      'clearSelectedTasks',
      'updateTask',
      'unassignPersonFromTask',
      'removeSelectedTask',
      'loadProjectTasks',
      'loadTask',
      'deleteTask',
      'removeSelectedTask',
    ]),

    onDeleteClick (tsk) {
      this.deleteTask({ task: tsk })
      this.updateList()
    },

    getTypeStyle (task) {
      return {
        color: 'white',
        background: task.task_type.color
      }
    },

    formatDate (date) {
      if (date) return moment(date).format('DD.MM.YYYY')
      else return ''
    },

    getDate (date) {
      return date ? moment(date, 'YYYY-MM-DD').toDate() : null
    },

    getRowStyle (task) {
      if (this.selectionGrid[task.id]) {
        const bgColor = this.isDarkTheme ? '#5e60ba' : '#bfc1ff'
        return { background: bgColor }
      } else {
        return {}
      }
    },

    selectTask (event, task) {
      this.selectionGrid = this.onLinearTaskSelect(task, event, this.selectionGrid, this.sortedTaskList)
    },

    getDepartmentName (task) {
      const department = this.departmentMap.get(task.task_type.department_id)
      if (department) {
        return department.name
      } else {
        return null
      }
    },

    getDepartmentRowspan (index) {
      const taskList = this.sortedTaskList
      const departmentId = taskList[index].task_type.department_id
      if (index > 0 && taskList[index - 1].task_type.department_id === departmentId) {
        return false
      }
      var rowspan = 0
      for (var i = index; i < taskList.length; i++) {
        if (taskList[i].task_type.department_id === departmentId) {
          rowspan++
        }
      }
      return rowspan
    },

    getDepartmentStyle (task) {
      const department = this.departmentMap.get(task.task_type.department_id)
      if (department) {
        return { 'background-color': department.color }
      } else {
        return {}
      }
    },

    updateStartDate (date) {
      Object.keys(this.selectionGrid).forEach(taskId => {
        let data = {
          start_date: null,
          due_date: null
        }
        const task = this.taskMap.get(taskId)
        const dueDate = task.due_date ? parseSimpleDate(task.due_date) : null
        if (date) {
          const startDate = moment(date)
          if (
            task.start_date &&
            task.start_date.substring(0, 10) === formatSimpleDate(startDate)
          ) return
          data = getDatesFromStartDate(
            startDate,
            dueDate,
            minutesToDays(this.organisation, task.estimation)
          )
        } else {
          data = {
            start_date: null,
            due_date: dueDate
          }
        }
        if (this.isTaskChanged(task, data)) {
          this.updateTask({ taskId, data })
            .catch(console.error)
        }
      })
    },

    updateDueDate (date) {
      Object.keys(this.selectionGrid).forEach(taskId => {
        let data = {
          start_date: null,
          due_date: null
        }
        const task = this.taskMap.get(taskId)
        const startDate = task.start_date ? parseSimpleDate(task.start_date) : null
        if (date) {
          const dueDate = moment(date)
          if (
            task.due_date &&
            task.due_date.substring(0, 10) === formatSimpleDate(dueDate)
          ) return
          data = getDatesFromEndDate(
            startDate,
            dueDate,
            minutesToDays(this.organisation, task.estimation)
          )
        } else {
          data = {
            start_date: startDate,
            due_date: null
          }
        }
        if (this.isTaskChanged(task, data)) {
          this.updateTask({ taskId, data })
            .catch(console.error)
        }
      })
    },

    updateSortedList () {
      this.sortedTaskList = [...this.tasks]
      if (this.sortedTaskList.length > 0) {
        this.sortedTaskList = this.sortedTaskList.sort((a, b) => {
          const taskTypeA = a.task_type
          const taskTypeB = b.task_type
          const departmentA = this.departmentMap.get(taskTypeA.department_id)
          const departmentB = this.departmentMap.get(taskTypeB.department_id)
          const taskTypeAPriority = getTaskTypePriorityOfProd(
            taskTypeA, this.currentProduction
          )
          const taskTypeBPriority = getTaskTypePriorityOfProd(
            taskTypeB, this.currentProduction
          )
          if (departmentA && departmentB && departmentA.id !== departmentB.id) {
            return departmentA.name.localeCompare(departmentB.name)
          } else {
            if (taskTypeAPriority === taskTypeBPriority) {
              return taskTypeA.name.localeCompare(taskTypeB.name)
            } else if (taskTypeAPriority > taskTypeBPriority) {
              return 1
            } else {
              return -1
            }
          }
        })
        if (this.departmentFilter && this.departmentFilter.length > 0) {
          this.sortedTaskList = this.sortedTaskList.filter((task) => {
            return this.departmentFilter.includes(task.task_type.department_id)
          })
        }
      }
    },

    isTaskChanged (task, data) {
      const taskStart = task.start_date ? task.start_date.substring(0, 10) : ''
      const taskDue = task.due_date ? task.due_date.substring(0, 10) : ''
      return (
        (data.start_date !== undefined && taskStart !== data.start_date) ||
        (data.due_date !== undefined && taskDue !== data.due_date) ||
        (data.estimation !== undefined && task.estimation !== data.estimation)
      )
    }
  },

  watch: {
    departmentFilter() {
      this.updateSortedList()
    }
  },

  mounted () {
    this.updateSortedList()
  }
}
</script>

<style scoped lang="scss">
.asset-type {
  min-width: 120px;
  width: 120px;
}

.sequence {
  min-width: 120px;
  width: 120px;
}

.name {
  min-width: 120px;
  width: 120px;
  font-weight: bold;
}

.status {
  min-width: 100px;
  width: 100px;
}

.assignees {
  min-width: 100px;
  width: 100px;
}

.frames,
.duration,
.estimation {
  min-width: 60px;
  width: 60px;
  text-align: center;
}

.last-comment-date,
.real-start-date,
.real-end-date {
  min-width: 110px;
  max-width: 110px;
  width: 110px;
}

th.start-date,
th.due-date {
  min-width: 106px;
  max-width: 106px;
  width: 106px;
}

td.start-date,
td.due-date {
  text-align: center;
  margin: 0;
  padding: 0;
}

.retake-count {
  min-width: 90px;
  width: 90px;
}

td.retake-count {
  line-height: 0.5em;
  color: $red;
  font-weight: bold;
  font-size: 1.6em;
  padding-left: 2px;
}

.empty {
  width: 100%
}

.nb-tasks {
  padding: 0.5em;
}

.table-header th {
  padding: 0.5em 0;

  &.retake-count {
    padding-right: 1em;
  }

  &.status {
    padding-left: 1em;
  }
}

.datatable-head {
  th {
    padding-left: 0;

    &.retake-count {
      padding-right: 1em;
    }

    &.status {
      padding-left: 1em;
      padding-right: 1em;
    }
  }
}

.input {
  padding: 0.5em
}

.datatable-wrapper {
  min-height: calc(100% - 50px);
}

.datatable-body {
  overflow-x: auto;
  overflow-y: scroll;
  min-height: 100%;

  td,
  tr {
    padding: 0;

    &.thumbnail {
      padding: 6px;
    }
  }

  td.retake-count {
    padding-right: 1em;
  }

  td.status {
    padding-left: 1em;
    padding-right: 1em;
  }

  tr.task-line {
    cursor: pointer;
  }
}

.dark-row > td {
  color: #ffffff;
}

.data-list {
  height: 80%;
}

td.task-type {
  border-left: none;
  border-top: none;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  padding-left: 4px;
}

td.department {
  border-left: 1px solid black;
  border-top: none;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  padding-left: 4px;
}

.task-type {
  min-width: 10em;
  border-radius: 0 !important;
}

.department {
  min-width: 10em;
  border-radius: 0 !important;
}
</style>
